/**
 * ANOTHR Founder Story — Interactivity
 * Taste-Skill optimized: GPU-safe, throttled, null-safe
 */

document.addEventListener('DOMContentLoaded', () => {
    const ctaBar = document.querySelector('.fs-cta-bar');
    const heroSection = document.querySelector('#fs-hero');
    const handImg = document.querySelector('.fs-hero__hand-placeholder img');
    // --- Scroll handler (single, RAF-throttled) ---
    let ticking = false;

    function onScroll() {
        if (ticking) return;
        ticking = true;

        requestAnimationFrame(() => {
            // 1. CTA bar visibility
            if (heroSection && ctaBar) {
                const heroBottom = heroSection.getBoundingClientRect().bottom;
                if (heroBottom < window.innerHeight) {
                    ctaBar.classList.add('is-visible');
                } else {
                    ctaBar.classList.remove('is-visible');
                }
            }

            // 2. Hand scale on scroll (GPU-safe transform only)
            if (heroSection && handImg) {
                const rect = heroSection.getBoundingClientRect();
                const progress = Math.max(0, Math.min(1, -rect.top / (rect.height - window.innerHeight)));
                handImg.style.transform = `scale(${1 + progress * 0.05})`;
            }

            ticking = false;
        });
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    // --- Scroll-triggered fade-up animations (IntersectionObserver) ---
    const fadeEls = document.querySelectorAll('.fs-fade-up');

    if (fadeEls.length > 0 && 'IntersectionObserver' in window) {
        const fadeObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    fadeObserver.unobserve(entry.target);
                }
            });
        }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

        fadeEls.forEach(el => fadeObserver.observe(el));
    }
});
